import { FORM_TYPES, MODAL_TYPES, MODIFIER_TYPE, TRIAL_TYPES } from '../consts';
import { useAppStore } from '../store/appStore';
import { getFlowType } from './getFlowType';

export const getExperimentVersion = () => {
  const { modifier, trialType, isLoggedIn } = useAppStore.getState();
  const params = new URLSearchParams(window.location.search);
  const hasFreePath = window.location.pathname.includes('/free');
  const freePremium = params.get('experiment_version') === 'TPR5_sitecore_free_premium';
  const isPassGenControl = params.get('experiment_version') === 'Password_Generator_Control';
  const isChevyControl = params.get('experiment_version') === '2Step_Modal';
  const exp_version = params.get('exp_version');

  if (exp_version) return exp_version;
  if (modifier === MODAL_TYPES.BIZMAX) return 'Business_Max_Modal';
  if (isPassGenControl) return 'Password_Generator_Control';
  if (modifier === MODAL_TYPES.PASSWORDGEN) return 'Password_Generator_Modal';
  if (modifier === MODIFIER_TYPE.HERO) return `Hero_Trial_${trialType}`;
  if (modifier === MODAL_TYPES.UNIFIED) return 'Unified_Trial';
  if (modifier === MODAL_TYPES.UNIFIED_CHEVY_PREMIUM) return 'Unified_Chevy_Premium';
  if (modifier === MODAL_TYPES.CHEVYPREMIUM) return '2Step_Modal_Premium';
  if (modifier === MODAL_TYPES.CHEVYPREMIUM_CONTROL) return '2Step_Modal_Premium_Control';
  if (modifier === MODAL_TYPES.CHEVYPREMIUM_CONTROL1) return '2Step_Modal_Premium_Control1';
  if (modifier === MODAL_TYPES.CHEVYPREMIUM_PERSONAL) return '2Step_Modal_Premium_Personal';
  if (modifier === MODAL_TYPES.CHEVY || isChevyControl) return '2Step_Modal';
  if (trialType === TRIAL_TYPES.PREMIUM && freePremium) return 'TPR5_sitecore_free_premium';
  if (trialType === TRIAL_TYPES.PREMIUM && hasFreePath) return 'TPR5_sitecore_free_free';
  if (trialType === TRIAL_TYPES.PREMIUM) return 'TPR5_sitecore_premium';
  if (trialType === TRIAL_TYPES.FAMILIES) return 'TPR_Phase6';
  if (trialType === TRIAL_TYPES.MSP) return 'TPR_MSP_phase1';
  if (trialType === TRIAL_TYPES.TEAMS) return 'TPR_Phase4_teams';
  if (isLoggedIn) return 'TPR_Phase2';
  return 'TPR_Phase1';
};

export const getEventName = (legacy?: boolean) => {
  const { modifier, trialType } = useAppStore.getState();
  if (modifier === MODAL_TYPES.UNIFIED) return MODAL_TYPES.UNIFIED.toLowerCase();
  if (modifier === MODAL_TYPES.UNIFIED_CHEVY_PREMIUM && trialType !== TRIAL_TYPES.BUSINESS)
    return MODAL_TYPES.UNIFIED.toLowerCase();
  if (trialType === TRIAL_TYPES.PREMIUM) return TRIAL_TYPES.PREMIUM;
  if (trialType === TRIAL_TYPES.FAMILIES) return TRIAL_TYPES.FAMILIES;
  if (trialType === TRIAL_TYPES.MSP) return TRIAL_TYPES.MSP;
  if (trialType === TRIAL_TYPES.TEAMS) return TRIAL_TYPES.TEAMS;
  return legacy ? TRIAL_TYPES.ENTERPRISE : TRIAL_TYPES.BUSINESS;
};

export const getEventReason = () => {
  const { formType, trialType, businessMax, isLPPlus } = useAppStore.getState();
  const params = new URLSearchParams(window.location.search);
  let isMax = params.has('max') || businessMax;
  const flowType = getFlowType(formType);

  if (flowType === FORM_TYPES.PURCHASE) {
    return isMax
      ? 'businessmax_direct_buy'
      : trialType === TRIAL_TYPES.PREMIUM
        ? isLPPlus
          ? 'plus_direct_buy'
          : `premium_direct_buy`
        : `${getEventName()}_buy_start`;
  } else {
    return isMax ? 'businessmax' : `${getEventName()}_trial_start`;
  }
};

export const getUserCheckEndpoint = () => {
  const { trialType } = useAppStore.getState();

  if (trialType === TRIAL_TYPES.MSP) return 'MspEmailCheck';
  if (trialType === TRIAL_TYPES.TEAMS) return 'TeamsEmailCheck';
  if (trialType === TRIAL_TYPES.PREMIUM) return 'PremiumEmailCheck';
  if (trialType === TRIAL_TYPES.FAMILIES) return 'FamiliesEmailCheck';
  return 'EmailCheckBusinessUser';
};
